//
// ENUMERATORS
// Description: List of common or predefined Lookup Variables
// Note       : Can create methods to accept Enum as Parameter to return values
//

import moment from 'moment'

//#region Permission
export enum PermissionModule {
  Internal = 1,
  External = 2,
}

export enum Group {
  IT_Administrator = 1,

  Secretariat_User_Administrator = 2,
  Secretariat_Normal_User = 3,
  Secretariat_Cluster_Head = 4,
  Secretariat_Stakeholder = 5,

  Member_User_Administrator = 6,
  Member_Normal_User = 7,
  Member_Stakeholder = 8,

  Partner_User_Administrator = 9,
  Partner_Normal_User = 10,
  Partner_Stakeholder = 11,
}
export const GetGroupIcon = (group: Group) => {
  switch (group) {
    case Group.IT_Administrator:
    case Group.Secretariat_User_Administrator:
    case Group.Member_User_Administrator:
    case Group.Partner_User_Administrator:
      return 'fas fa-user-tie'
    case Group.Secretariat_Normal_User:
    case Group.Member_Normal_User:
    case Group.Partner_Normal_User:
      return 'fas fa-user'
    case Group.Secretariat_Cluster_Head:
      return 'fas fa-user-ninja'
    case Group.Secretariat_Stakeholder:
    case Group.Member_Stakeholder:
    case Group.Partner_Stakeholder:
      return 'fas fa-user-secret'
    default:
      return ''
  }
}

export enum Role {
  INT_System = 1,

  INT_User_Full = 2,
  INT_User_Read = 3,
  INT_Maintenance_Full = 4,
  INT_Maintenance_Read = 5,
  INT_Profile_Full = 6,
  INT_Profile_Read = 7,
  INT_Submission_Full = 8,
  INT_Submission_Read = 9,
  INT_Report_Full = 10,
  INT_Report_Read = 11,
  INT_Announcement_Full = 12,
  INT_Announcement_Read = 13,

  EXT_User_Full = 14,
  EXT_User_Read = 15,
  EXT_Maintenance_Full = 16,
  EXT_Maintenance_Read = 17,
  EXT_Profile_Full = 18,
  EXT_Profile_Read = 19,
  EXT_Submission_Full = 20,
  EXT_Submission_Read = 21,
  EXT_Report_Full = 22,
  EXT_Report_Read = 23,
}

export enum UserActive {
  Active = 'true',
  Inactive = 'false',
}
export const GetUserActiveBackground = (userActive: UserActive) => {
  switch (userActive) {
    case UserActive.Active:
      return 'success'
    case UserActive.Inactive:
      return 'light'
    default:
      return ''
  }
}
export const GetUserActiveColor = (userActive: UserActive) => {
  switch (userActive) {
    case UserActive.Active:
      return 'white'
    case UserActive.Inactive:
      return 'dark'
    default:
      return ''
  }
}
export const GetUserActiveIcon = (userActive: UserActive) => {
  switch (userActive) {
    case UserActive.Active:
      return 'fas fa-user-check'
    case UserActive.Inactive:
      return 'fas fa-user-xmark'
    default:
      return ''
  }
}
export const GetUserActiveText = (userActive: UserActive) => {
  switch (userActive) {
    case UserActive.Active:
      return 'Active'
    case UserActive.Inactive:
      return 'Inactive'
    default:
      return ''
  }
}

export enum UserEmailConfirmed {
  Verified = 'true',
  Unverified = 'false',
}
export const GetUserEmailConfirmedBackground = (userEmailConfirmed: UserEmailConfirmed) => {
  switch (userEmailConfirmed) {
    case UserEmailConfirmed.Verified:
      return 'success'
    case UserEmailConfirmed.Unverified:
      return 'light'
    default:
      return ''
  }
}
export const GetUserEmailConfirmedColor = (userEmailConfirmed: UserEmailConfirmed) => {
  switch (userEmailConfirmed) {
    case UserEmailConfirmed.Verified:
      return 'white'
    case UserEmailConfirmed.Unverified:
      return 'dark'
    default:
      return ''
  }
}
export const GetUserEmailConfirmedIcon = (userEmailConfirmed: UserEmailConfirmed) => {
  switch (userEmailConfirmed) {
    case UserEmailConfirmed.Verified:
      return 'fas fa-check'
    case UserEmailConfirmed.Unverified:
      return 'fas fa-xmark'
    default:
      return ''
  }
}
export const GetUserEmailConfirmedText = (userEmailConfirmed: UserEmailConfirmed) => {
  switch (userEmailConfirmed) {
    case UserEmailConfirmed.Verified:
      return 'Verified'
    case UserEmailConfirmed.Unverified:
      return 'Unverified'
    default:
      return ''
  }
}

export enum DirectoryMode {
  Thumbnail = 'true',
  List = 'false',
}
export const GetDirectoryModeIcon = (directoryMode: DirectoryMode) => {
  switch (directoryMode) {
    case DirectoryMode.Thumbnail:
      return 'fas fa-grip'
    case DirectoryMode.List:
      return 'fas fa-list-ul'
    default:
      return ''
  }
}

//#endregion

//#region Theme
export enum Module {
  Dashboard = 100,
  Pledge = 200,
  Submission = 300,
  Program = 310,
  Location = 320,
  Beneficiary = 330,
  Contribution = 340,
  Document = 350,
  Rating = 360,
  Maintenance = 400,
  Maintenance_User = 410,
  Maintenance_List = 420,
  Maintenance_List_Category = 421,
  Announcements = 500,
  Reports = 600,
  Directory = 700,
  Directory_Members = 710,
  Directory_Partners = 720,
  ContactUs = 950,
  Notification = 960,
  Profile = 970,
  Logout = 980,
}
export const GetModuleColor = (module: Module) => {
  switch (module) {
    case Module.Dashboard:
      return 'primary'
    case Module.Pledge:
      return 'primary'
    case Module.Submission:
      return 'primary'
    case Module.Program:
      return 'primary'
    case Module.Location:
      return 'primary'
    case Module.Beneficiary:
      return 'primary'
    case Module.Contribution:
      return 'primary'
    case Module.Document:
      return 'primary'
    case Module.Rating:
      return 'primary'
    case Module.Announcements:
      return 'info'
    case Module.Reports:
      return 'warning'
    case Module.Directory:
      return 'success'
    case Module.Directory_Members:
      return 'success'
    case Module.Directory_Partners:
      return 'success'
    case Module.Maintenance:
      return 'primary'
    case Module.Maintenance_User:
      return 'primary'
    case Module.Maintenance_List:
      return 'primary'
    case Module.Maintenance_List_Category:
      return 'primary'
    case Module.ContactUs:
      return 'success'
    case Module.Notification:
      return 'info'
    case Module.Profile:
      return 'primary'
    case Module.Logout:
      return 'danger'
    default:
      return ''
  }
}
export const GetModuleIcon = (module: Module) => {
  switch (module) {
    case Module.Dashboard:
      return 'bi-layout-wtf'
    case Module.Pledge:
      return 'fas fa-hand'
    case Module.Submission:
      return 'fas fa-hand-holding-heart'
    case Module.Program:
      return '/media/logos/favicon.svg'
    case Module.Location:
      return 'fas fa-location-dot'
    case Module.Beneficiary:
      return 'fas fa-people-carry-box'
    case Module.Contribution:
      return 'fas fa-boxes-packing'
    case Module.Document:
      return 'fas fa-paperclip'
    case Module.Rating:
      return 'fas fa-building-ngo'
    case Module.Announcements:
      return 'bi-chat-dots'
    case Module.Reports:
      return 'bi-journal-text'
    case Module.Directory:
      return 'fas fa-building-user'
    case Module.Maintenance:
      return 'bi-wrench-adjustable'
    case Module.Maintenance_User:
      return 'fas fa-user-gear'
    case Module.Maintenance_List:
      return 'bi bi-menu-down'
    case Module.Maintenance_List_Category:
      return 'fas fa-sitemap'
    case Module.ContactUs:
      return 'bi-headset'
    case Module.Notification:
      return 'bi-bell'
    case Module.Profile:
      return 'bi-person-circle'
    case Module.Logout:
      return 'bi-escape'
    default:
      return ''
  }
}
export const GetModulePath = (module: Module) => {
  switch (module) {
    case Module.Dashboard:
      return '/dashboard'
    case Module.Pledge:
      return '/pledge'
    case Module.Submission:
      return '/program'
    case Module.Reports:
      return '/reports'
    case Module.Directory:
      return '/directory'
    case Module.Directory_Members:
      return '/directory/members'
    case Module.Directory_Partners:
      return '/directory/partners'
    case Module.Maintenance:
      return '/maintenance'
    case Module.Maintenance_User:
      return '/maintenance/user'
    case Module.Maintenance_List:
      return '/maintenance/list'
    case Module.Maintenance_List_Category:
      return '/maintenance/list/category'
    case Module.Notification:
      return '/'
    case Module.Profile:
      return '/profile'
    case Module.Logout:
      return '/'
    default:
      return ''
  }
}
export const GetModuleText = (module: Module) => {
  switch (module) {
    case Module.Dashboard:
      return 'Dashboard'
    case Module.Pledge:
      return 'Pledge'
    case Module.Submission:
      return 'Program'
    case Module.Reports:
      return 'Reports'
    case Module.Directory:
      return 'Directory'
    case Module.Directory_Members:
      return 'Members'
    case Module.Directory_Partners:
      return 'Partners'
    case Module.Maintenance:
      return 'Maintenance'
    case Module.Maintenance_User:
      return 'User'
    case Module.Maintenance_List:
      return 'List'
    case Module.Maintenance_List_Category:
      return 'Member Categorisation'
    case Module.Notification:
      return 'Notification'
    case Module.Profile:
      return 'Profile'
    case Module.Logout:
      return 'Logout'
    default:
      return ''
  }
}

export enum NotificationIconColor {
  Primary = 1,
  Secondary = 2,
  Success = 3,
  Info = 4,
  Warning = 5,
  Danger = 6,
  White = 7,
  Dark = 8,
}
export const GetNotificationColor = (color: NotificationIconColor) => {
  switch (color) {
    case NotificationIconColor.Primary:
      return 'primary'
    case NotificationIconColor.Secondary:
      return 'secondary'
    case NotificationIconColor.Success:
      return 'success'
    case NotificationIconColor.Info:
      return 'info'
    case NotificationIconColor.Warning:
      return 'warning'
    case NotificationIconColor.Danger:
      return 'danger'
    case NotificationIconColor.White:
      return 'white'
    case NotificationIconColor.Dark:
      return 'dark'
    default:
      return ''
  }
}
//#endregion

//#region List
export enum LookupModule {
  Filter = 1,
  Form = 2,
}
//#endregion

//#region Tab
export enum DirectoryTabEventKey {
  Members = 'tab.directory.members',
  Partners = 'tab.directory.partners',
}
//#endregion

//#region Form Section
export enum PledgeProgramFormSection {
  All = 99,
  PledgeProgram = 1,
  Locations = 2,
  Beneficiaries = 3,
  TargetedContributions = 4,
  Attachments = 5,
}
export const GetPledgeProgramFormSectionToast = (section: PledgeProgramFormSection) => {
  switch (section) {
    case PledgeProgramFormSection.All:
      return 'Pledge Program submitted successfully.'
    case PledgeProgramFormSection.PledgeProgram:
      return 'Pledge Program saved successfully.'
    case PledgeProgramFormSection.Locations:
      return 'Locations saved successfully.'
    case PledgeProgramFormSection.Beneficiaries:
      return 'Beneficiaries saved successfully.'
    case PledgeProgramFormSection.TargetedContributions:
      return 'Targeted Contributions saved successfully.'
    case PledgeProgramFormSection.Attachments:
      return 'Attachments saved successfully.'
    default:
      return ''
  }
}

export enum ProgramFormSection {
  All = 99,
  ProgramDetails = 1,
  Locations = 2,
  Beneficiaries = 3,
  TargetedContributions = 4,
  Rating = 5,
  Attachments = 6,
}
export const GetProgramFormSectionToast = (section: ProgramFormSection) => {
  switch (section) {
    case ProgramFormSection.All:
      return 'Program submitted successfully.'
    case ProgramFormSection.ProgramDetails:
      return 'Program Details saved successfully.'
    case ProgramFormSection.Locations:
      return 'Locations saved successfully.'
    case ProgramFormSection.Beneficiaries:
      return 'Beneficiaries saved successfully.'
    case ProgramFormSection.TargetedContributions:
      return 'Targeted Contributions saved successfully.'
    case ProgramFormSection.Rating:
      return 'Ratings saved successfully.'
    case ProgramFormSection.Attachments:
      return 'Attachments saved successfully.'
    default:
      return ''
  }
}
//#endregion

//#region Wizard Step
export enum PledgeInitiateStepEventKey {
  Step1 = 'step.pledgeInitiate.ONE.1',
  Step2 = 'step.pledgeInitiate.TWO.2',
  Step3 = 'step.pledgeInitiate.THREE.3',
  Step4 = 'step.pledgeInitiate.FOUR.4',
  Step5 = 'step.pledgeInitiate.FIVE.5',
}
export const GetPledgeInitiateStepTitle = (pledgeInitiateStep: PledgeInitiateStepEventKey) => {
  switch (pledgeInitiateStep) {
    case PledgeInitiateStepEventKey.Step1:
      return 'Pledge Program'
    case PledgeInitiateStepEventKey.Step2:
      return 'Locations'
    case PledgeInitiateStepEventKey.Step3:
      return 'Beneficiaries'
    case PledgeInitiateStepEventKey.Step4:
      return 'Targeted Contributions'
    case PledgeInitiateStepEventKey.Step5:
      return 'Attachments'
    default:
      return ''
  }
}
export const GetPledgeInitiateStepIcon = (pledgeInitiateStep: PledgeInitiateStepEventKey) => {
  switch (pledgeInitiateStep) {
    case PledgeInitiateStepEventKey.Step1:
      return GetModuleIcon(Module.Pledge)
    case PledgeInitiateStepEventKey.Step2:
      return GetModuleIcon(Module.Location)
    case PledgeInitiateStepEventKey.Step3:
      return GetModuleIcon(Module.Beneficiary)
    case PledgeInitiateStepEventKey.Step4:
      return GetModuleIcon(Module.Contribution)
    case PledgeInitiateStepEventKey.Step5:
      return GetModuleIcon(Module.Document)
    default:
      return ''
  }
}

export enum PledgeRequestStepEventKey {
  Step1 = 'step.pledgeRequest.ONE.1',
  Step2 = 'step.pledgeRequest.TWO.2',
  Step3 = 'step.pledgeRequest.THREE.3',
  Step4 = 'step.pledgeRequest.FOUR.4',
  Step5 = 'step.pledgeRequest.FIVE.5',
}
export const GetPledgeRequestStepTitle = (pledgeRequestStep: PledgeRequestStepEventKey) => {
  switch (pledgeRequestStep) {
    case PledgeRequestStepEventKey.Step1:
      return 'Pledge Program'
    case PledgeRequestStepEventKey.Step2:
      return 'Locations'
    case PledgeRequestStepEventKey.Step3:
      return 'Beneficiaries'
    case PledgeRequestStepEventKey.Step4:
      return 'Targeted Contributions'
    case PledgeRequestStepEventKey.Step5:
      return 'Attachments'
    default:
      return ''
  }
}
export const GetPledgeRequestStepIcon = (pledgeRequestStep: PledgeRequestStepEventKey) => {
  switch (pledgeRequestStep) {
    case PledgeRequestStepEventKey.Step1:
      return GetModuleIcon(Module.Pledge)
    case PledgeRequestStepEventKey.Step2:
      return GetModuleIcon(Module.Location)
    case PledgeRequestStepEventKey.Step3:
      return GetModuleIcon(Module.Beneficiary)
    case PledgeRequestStepEventKey.Step4:
      return GetModuleIcon(Module.Contribution)
    case PledgeRequestStepEventKey.Step5:
      return GetModuleIcon(Module.Document)
    default:
      return ''
  }
}
export const GetPledgeRequestStepFormSection = (pledgeRequestStep: PledgeRequestStepEventKey) => {
  switch (pledgeRequestStep) {
    case PledgeRequestStepEventKey.Step1:
      return PledgeProgramFormSection.PledgeProgram
    case PledgeRequestStepEventKey.Step2:
      return PledgeProgramFormSection.Locations
    case PledgeRequestStepEventKey.Step3:
      return PledgeProgramFormSection.Beneficiaries
    case PledgeRequestStepEventKey.Step4:
      return PledgeProgramFormSection.TargetedContributions
    case PledgeRequestStepEventKey.Step5:
      return PledgeProgramFormSection.Attachments
    default:
      return PledgeProgramFormSection.PledgeProgram
  }
}

export enum SubmissionStepEventKey {
  Step1 = 'step.submission.ONE.1',
  Step2 = 'step.submission.TWO.2',
  Step3 = 'step.submission.THREE.3',
  Step4 = 'step.submission.FOUR.4',
  Step5 = 'step.submission.FIVE.5',
  Step6 = 'step.submission.SIX.6',
}
export const GetSubmissionStepTitle = (submissionStep: SubmissionStepEventKey) => {
  switch (submissionStep) {
    case SubmissionStepEventKey.Step1:
      return 'Program Details'
    case SubmissionStepEventKey.Step2:
      return 'Locations'
    case SubmissionStepEventKey.Step3:
      return 'Beneficiaries'
    case SubmissionStepEventKey.Step4:
      return 'Contributions'
    case SubmissionStepEventKey.Step5:
      return 'Partners'
    case SubmissionStepEventKey.Step6:
      return 'Attachments'
    default:
      return ''
  }
}
export const GetSubmissionStepIcon = (submissionStep: SubmissionStepEventKey) => {
  switch (submissionStep) {
    case SubmissionStepEventKey.Step1:
      return GetModuleIcon(Module.Program)
    case SubmissionStepEventKey.Step2:
      return GetModuleIcon(Module.Location)
    case SubmissionStepEventKey.Step3:
      return GetModuleIcon(Module.Beneficiary)
    case SubmissionStepEventKey.Step4:
      return GetModuleIcon(Module.Contribution)
    case SubmissionStepEventKey.Step5:
      return GetModuleIcon(Module.Rating)
    case SubmissionStepEventKey.Step6:
      return GetModuleIcon(Module.Document)
    default:
      return ''
  }
}
export const GetSubmissionStepFormSection = (submissionStep: SubmissionStepEventKey) => {
  switch (submissionStep) {
    case SubmissionStepEventKey.Step1:
      return ProgramFormSection.ProgramDetails
    case SubmissionStepEventKey.Step2:
      return ProgramFormSection.Locations
    case SubmissionStepEventKey.Step3:
      return ProgramFormSection.Beneficiaries
    case SubmissionStepEventKey.Step4:
      return ProgramFormSection.TargetedContributions
    case SubmissionStepEventKey.Step5:
      return ProgramFormSection.Rating
    case SubmissionStepEventKey.Step6:
      return ProgramFormSection.Attachments
    default:
      return ProgramFormSection.ProgramDetails
  }
}

export enum DirectoryMembersStepEventKey {
  Step1 = 'step.members.ONE.1',
  Step2 = 'step.members.TWO.2',
}
export const GetDirectoryMembersStepTitle = (directoryMemberStep: DirectoryMembersStepEventKey) => {
  switch (directoryMemberStep) {
    case DirectoryMembersStepEventKey.Step1:
      return 'Organisation'
    case DirectoryMembersStepEventKey.Step2:
      return 'Contacts'
    default:
      return ''
  }
}
export const GetDirectoryMembersStepIcon = (directoryMemberStep: DirectoryMembersStepEventKey) => {
  switch (directoryMemberStep) {
    case DirectoryMembersStepEventKey.Step1:
      return 'fas fa-building'
    case DirectoryMembersStepEventKey.Step2:
      return 'fas fa-address-book'
    default:
      return ''
  }
}

export enum DirectoryPartnersStepEventKey {
  Step1 = 'step.partners.ONE.1',
  Step2 = 'step.partners.TWO.2',
  Step3 = 'step.partners.THREE.3',
}
export const GetDirectoryPartnersStepTitle = (directoryPartnerStep: DirectoryPartnersStepEventKey) => {
  switch (directoryPartnerStep) {
    case DirectoryPartnersStepEventKey.Step1:
      return 'Organisation'
    case DirectoryPartnersStepEventKey.Step2:
      return 'Contacts'
    case DirectoryPartnersStepEventKey.Step3:
      return 'Ratings & Comments'
    default:
      return ''
  }
}
export const GetDirectoryPartnersStepIcon = (directoryPartnerStep: DirectoryPartnersStepEventKey) => {
  switch (directoryPartnerStep) {
    case DirectoryPartnersStepEventKey.Step1:
      return 'fas fa-building'
    case DirectoryPartnersStepEventKey.Step2:
      return 'fas fa-address-book'
    case DirectoryPartnersStepEventKey.Step3:
      return 'fas fa-star'
    default:
      return ''
  }
}
//#endregion

//#region Lookup List
export enum ActivityTrackingAction {
  Program_Submitted_OnGoing = 10,
  Program_Submitted_Completed = 11,
  Program_Updated_OnGoing = 12,
  Program_Updated_Reopened = 13,
  Program_Updated_Completed = 14,
  Program_Reopened = 15,
  Program_Resubmitted_OnGoing = 16,
  Program_Resubmitted_Completed = 17,
  Program_Deleted = 18,
  Program_Updated_Rating = 19,
  Program_Updated_Comment = 20,
}
export const GetActivityTrackingActionColor = (activityTrackingAction: ActivityTrackingAction) => {
  switch (activityTrackingAction) {
    case ActivityTrackingAction.Program_Submitted_OnGoing:
      return 'success'
    case ActivityTrackingAction.Program_Submitted_Completed:
      return 'success'
    case ActivityTrackingAction.Program_Updated_OnGoing:
      return 'primary'
    case ActivityTrackingAction.Program_Updated_Reopened:
      return 'primary'
    case ActivityTrackingAction.Program_Updated_Completed:
      return 'primary'
    case ActivityTrackingAction.Program_Updated_Rating:
      return 'primary'
    case ActivityTrackingAction.Program_Updated_Comment:
      return 'primary'
    case ActivityTrackingAction.Program_Reopened:
      return 'warning'
    case ActivityTrackingAction.Program_Resubmitted_OnGoing:
      return 'success'
    case ActivityTrackingAction.Program_Resubmitted_Completed:
      return 'success'
    case ActivityTrackingAction.Program_Deleted:
      return 'danger'
    default:
      return ''
  }
}

export enum AnnouncementStatus {
  Draft = 0,
  Pending = 1,
  Published = 2,
  Expired = 3,
}
export const GetAnnouncementStatusBackground = (announcementStatus: AnnouncementStatus) => {
  switch (announcementStatus) {
    case AnnouncementStatus.Draft:
      return 'secondary'
    case AnnouncementStatus.Pending:
      return 'info'
    case AnnouncementStatus.Published:
      return 'success'
    case AnnouncementStatus.Expired:
      return 'dark'
    default:
      return ''
  }
}
export const GetAnnouncementStatusColor = (announcementStatus: AnnouncementStatus) => {
  switch (announcementStatus) {
    case AnnouncementStatus.Draft:
      return 'white'
    case AnnouncementStatus.Pending:
      return 'white'
    case AnnouncementStatus.Published:
      return 'white'
    case AnnouncementStatus.Expired:
      return 'white'
    default:
      return ''
  }
}
export const GetAnnouncementStatusIcon = (announcementStatus: AnnouncementStatus) => {
  switch (announcementStatus) {
    case AnnouncementStatus.Draft:
      return 'fas fa-circle-pause'
    case AnnouncementStatus.Pending:
      return 'fas fa-circle-info'
    case AnnouncementStatus.Published:
      return 'fas fa-circle-check'
    case AnnouncementStatus.Expired:
      return 'fas fa-circle-stop'
    default:
      return ''
  }
}
export const GetAnnouncementStatusText = (announcementStatus: AnnouncementStatus) => {
  switch (announcementStatus) {
    case AnnouncementStatus.Draft:
      return 'Draft'
    case AnnouncementStatus.Pending:
      return 'Pending Publish'
    case AnnouncementStatus.Published:
      return 'Published'
    case AnnouncementStatus.Expired:
      return 'Published & Expired'
    default:
      return ''
  }
}

export enum ApprovalStatus {
  /* 
    Draft = 1,
    Requested = 2, (Pending Approval)
    Approved = 3, < PledgeStartDate (Pending Published); >= PledgeStartDate (Published)
    Rejected = 4,
    Resubmitted = 5,
  */
  Draft = 1,
  Requested = 2,
  Approved = 3,
  Rejected = 4,
  Resubmitted = 5,
}
export const GetApprovalStatusBackground = (approvalStatus: ApprovalStatus) => {
  switch (approvalStatus) {
    case ApprovalStatus.Draft:
      return 'secondary'
    case ApprovalStatus.Requested:
      return 'info'
    case ApprovalStatus.Approved:
      return 'success'
    case ApprovalStatus.Rejected:
      return 'danger'
    case ApprovalStatus.Resubmitted:
      return 'warning'
    default:
      return ''
  }
}
export const GetApprovalStatusColor = (approvalStatus: ApprovalStatus) => {
  switch (approvalStatus) {
    case ApprovalStatus.Draft:
      return 'white'
    case ApprovalStatus.Requested:
      return 'white'
    case ApprovalStatus.Approved:
      return 'white'
    case ApprovalStatus.Rejected:
      return 'white'
    case ApprovalStatus.Resubmitted:
      return 'white'
    default:
      return ''
  }
}
export const GetApprovalStatusIcon = (approvalStatus: ApprovalStatus) => {
  switch (approvalStatus) {
    case ApprovalStatus.Draft:
      return 'fas fa-circle-pause'
    case ApprovalStatus.Requested:
      return 'fas fa-circle-info'
    case ApprovalStatus.Approved:
      return 'fas fa-circle-check'
    case ApprovalStatus.Rejected:
      return 'fas fa-circle-xmark'
    case ApprovalStatus.Resubmitted:
      return 'fas fa-circle-info'
    default:
      return ''
  }
}
export const GetApprovalStatusText = (approvalStatus: ApprovalStatus, pledgeStart: Date | undefined) => {
  if (approvalStatus === ApprovalStatus.Draft || pledgeStart === undefined) return 'Draft'
  else if (approvalStatus === ApprovalStatus.Requested) return 'Pending Approval'
  else if (approvalStatus === ApprovalStatus.Approved && moment(pledgeStart).isAfter(moment())) return 'Pending Published'
  else if (approvalStatus === ApprovalStatus.Approved && moment(pledgeStart).isSameOrBefore(moment())) return 'Published'
  else if (approvalStatus === ApprovalStatus.Rejected) return 'Rejected'
  else if (approvalStatus === ApprovalStatus.Resubmitted) return 'Resubmitted'
  return ''
}

export enum AttachmentType_PledgeProgram {
  LetterOfRequest = 1,
  ProposalDeck = 2,
}

export enum AttachmentType_Program {
  Attachments = 1,
  Links = 2,
}

export enum LookupStatus {
  Active = '1',
  Inactive = '0',
}
export const GetLookupStatusBackground = (lookupStatus: LookupStatus) => {
  switch (lookupStatus) {
    case LookupStatus.Active:
      return 'success'
    case LookupStatus.Inactive:
      return 'light'
    default:
      return ''
  }
}
export const GetLookupStatusColor = (lookupStatus: LookupStatus) => {
  switch (lookupStatus) {
    case LookupStatus.Active:
      return 'white'
    case LookupStatus.Inactive:
      return 'dark'
    default:
      return ''
  }
}
export const GetLookupStatusIcon = (lookupStatus: LookupStatus) => {
  switch (lookupStatus) {
    case LookupStatus.Active:
      return 'fas fa-check'
    case LookupStatus.Inactive:
      return 'fas fa-xmark'
    default:
      return ''
  }
}
export const GetLookupStatusText = (lookupStatus: LookupStatus) => {
  switch (lookupStatus) {
    case LookupStatus.Active:
      return 'Active'
    case LookupStatus.Inactive:
      return 'Inactive'
    default:
      return ''
  }
}

export enum NotificationType {
  // Program
  ProgramSubmitted = 1,
  ProgramReopened = 2,

  // Pledge Program
  PledgeSubmitted = 3,
  PledgeResubmitted = 4,
  PledgeApproved = 5,
  PledgeRejected = 6,
  PledgePublished = 7,
  PledgePledged = 8,
}
export const GetNotificationTypeIcon = (notificationType: NotificationType) => {
  switch (notificationType) {
    case NotificationType.ProgramSubmitted:
      return '/media/logos/favicon.svg'
    case NotificationType.ProgramReopened:
      return 'fas fa-rotate-left'
    case NotificationType.PledgeSubmitted:
      return 'fas fa-hand'
    case NotificationType.PledgeResubmitted:
      return 'fas fa-hand'
    case NotificationType.PledgeApproved:
      return 'fas fa-check'
    case NotificationType.PledgeRejected:
      return 'fas fa-rotate-left'
    case NotificationType.PledgePublished:
      return 'fas fa-hand'
    case NotificationType.PledgePledged:
      return 'fas fa-people-carry-box'
    default:
      return ''
  }
}

export enum OrganisationType {
  GLIC = 1,
  GLC = 2,
  Foundation = 3,
  NGO = 4,
}
export const GetOrganisationTypeText = (organisationType: OrganisationType) => {
  switch (organisationType) {
    case OrganisationType.GLIC:
      return 'GLIC'
    case OrganisationType.GLC:
      return 'GLC'
    case OrganisationType.Foundation:
      return 'Foundation'
    case OrganisationType.NGO:
      return 'NGO'
    default:
      return ''
  }
}

export enum ProgramStatus {
  Active = 1,
  OnGoing = 2,
  Completed = 3,
}
export const GetProgramStatusBackground = (programStatus: ProgramStatus) => {
  switch (programStatus) {
    case ProgramStatus.Active:
      return 'success'
    case ProgramStatus.OnGoing:
      return 'info'
    case ProgramStatus.Completed:
      return 'danger'
    default:
      return ''
  }
}
export const GetProgramStatusColor = (programStatus: ProgramStatus) => {
  switch (programStatus) {
    case ProgramStatus.Active:
      return 'white'
    case ProgramStatus.OnGoing:
      return 'white'
    case ProgramStatus.Completed:
      return 'white'
    default:
      return ''
  }
}
export const GetProgramStatusIcon = (programStatus: ProgramStatus) => {
  switch (programStatus) {
    case ProgramStatus.Active:
      return 'fas fa-circle-check'
    case ProgramStatus.OnGoing:
      return 'fas fa-circle-info'
    case ProgramStatus.Completed:
      return 'fas fa-circle-xmark'
    default:
      return ''
  }
}
export const GetProgramStatusText = (programStatus: ProgramStatus) => {
  switch (programStatus) {
    case ProgramStatus.Active:
      return 'Active'
    case ProgramStatus.OnGoing:
      return 'On Going'
    case ProgramStatus.Completed:
      return 'Completed'
    default:
      return ''
  }
}

export enum PledgeInitiationType {
  GDRN = 1,
  NGO = 2,
}

export enum PledgeProgramStatus {
  NotStarted = 1,
  OnGoing = 2,
  Ended = 3,
}

export enum SubmissionStatus {
  Draft = 1,
  ReOpened = 2,
  Submitted = 3,
}
export const GetSubmissionStatusBackground = (submissionStatus: SubmissionStatus) => {
  switch (submissionStatus) {
    case SubmissionStatus.Draft:
      return 'secondary'
    case SubmissionStatus.ReOpened:
      return 'warning'
    case SubmissionStatus.Submitted:
      return 'success'
    default:
      return ''
  }
}
export const GetSubmissionStatusColor = (submissionStatus: SubmissionStatus) => {
  switch (submissionStatus) {
    case SubmissionStatus.Draft:
      return 'white'
    case SubmissionStatus.ReOpened:
      return 'white'
    case SubmissionStatus.Submitted:
      return 'white'
    default:
      return ''
  }
}
export const GetSubmissionStatusIcon = (submissionStatus: SubmissionStatus) => {
  switch (submissionStatus) {
    case SubmissionStatus.Draft:
      return 'fas fa-circle-pause'
    case SubmissionStatus.ReOpened:
      return 'fas fa-circle-exclamation'
    case SubmissionStatus.Submitted:
      return 'fas fa-circle-check'
    default:
      return ''
  }
}
export const GetSubmissionStatusText = (submissionStatus: SubmissionStatus) => {
  switch (submissionStatus) {
    case SubmissionStatus.Draft:
      return 'Draft'
    case SubmissionStatus.ReOpened:
      return 'Re-opened'
    case SubmissionStatus.Submitted:
      return 'Submitted'
    default:
      return ''
  }
}

export enum GeneralStatus {
  Failed = -1,
  None = 0,
  Uploading = 1,
  Validating = 2,
  Importing = 3,
  Success = 4,
}

export enum ImportBatchStatus {
  None = 0,
  Uploading = 1,
  UploadFailed = 2,
  Validating = 3,
  ValidateFailed = 4,
  Importing = 5,
  ImportFailed = 6,
  Completed = 7,
  UnknownError = 8,
}

export enum SharingMode {
  OwnerOnly = 1,
  AllMembers = 2,
}

//#endregion
